import GlobalMessagePortal from './GlobalMessagePortal';
import './GlobalMessagePortal.scss';

export default GlobalMessagePortal;
